function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, InputNumber, Alert, Tag, Upload, Radio } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SaveSpiro = function SaveSpiro(_ref) {
  var candidat = _ref.candidat,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      file = _useState6[0],
      setFile = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("status", values.status);
    formData.append("comment", values.comment);
    formData.append("file", file);
    axios.post(Common.baseApiUrl + "setspirodata", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      comment: "",
      status: 1
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        padding: "20px",
        background: "#B7693F",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: ["Sauvegarder les donn\xE9s de spirometrie pour le candidat ", /*#__PURE__*/_jsx("b", {
        children: candidat.name
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "status",
        label: "Status",
        rules: [{
          required: true,
          message: 'Champs obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'NORMAL',
            value: 1
          }, {
            label: 'ANORMAL',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "comment",
        label: "Commentaire",
        children: /*#__PURE__*/_jsx(Input.TextArea, {
          autoSize: {
            minRows: 9,
            maxRows: 12
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            icon: /*#__PURE__*/_jsx(UploadIcon, {
              size: 20
            }),
            children: /*#__PURE__*/_jsx("b", {
              children: "JOINDRE UN FICHIER"
            })
          })
        }))
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })]
  });
};

export default SaveSpiro;